//eslint-disable-next-line
const reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
//eslint-disable-next-line
const reAlphanumeric = /^[a-zA-Z0-9\s]*$/;
//eslint-disable-next-line
const reAlphabetical = /^[a-zA-Z\s]*$/;
//eslint-disable-next-line
const reNonSpace = /^\S+$/;
//eslint-disable-next-line
const rePhone = /^[0-9]{3,}[0-9\-]*$/;

const prepareValue = v => v.toLowerCase().trim();

export const REQUIRED = 'REQUIRED';
export const SINGLE = 'SINGLE';
export const ALPHANUMERIC = 'ALPHANUMERIC';
export const ALPHABETICAL = 'ALPHABETICAL';
export const EMAIL = 'EMAIL';
export const PHONE = 'PHONE';

const errorMessageMap = {
  [REQUIRED]: v => v + ' should not be empty',
  [SINGLE]: v => v + ' should not contain spaces',
  [ALPHANUMERIC]: v => v + ' should not contain special symbols',
  [ALPHABETICAL]: v => v + ' should be alphabetical',
  [EMAIL]: v => v + ' is not valid',
  [PHONE]: v => v + ' is not valid',
}

const validationMap = {
  [REQUIRED]: v => v.length > 0,
  [SINGLE]: v => reNonSpace.test(v),
  [ALPHANUMERIC]: v => reAlphanumeric.test(v),
  [ALPHABETICAL]: v => reAlphabetical.test(v),
  [EMAIL]: v => reEmail.test(v),
  [PHONE]: v => rePhone.test(v),
}

export const validate = (v, rules, name) => {
  const value = prepareValue(v);
  rules.forEach(rule => {
    if (!validationMap[rule](value)) {
      throw new Error(errorMessageMap[rule](name));
    };
  });

  return true;
}